import { BaseInjectorService } from "src/app/base/base-service.injecter";
import { ButtonRendererComponent } from "./button-renderer/button-renderer.component";
import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  AfterViewInit,
  Output,
  EventEmitter,
} from "@angular/core";
import { GridOptions } from "ag-grid-community";
import { Subscription } from "rxjs";

@Component({
  selector: "lh-table",
  templateUrl: "./lh-table.component.html",
  styleUrls: ["./lh-table.component.scss"],
  standalone: false,
})
export class LhTableComponent
  extends BaseInjectorService
  implements OnInit, OnDestroy, AfterViewInit
{
  gridApi;
  editType;
  editingRowIndex;
  frameworkComponents;
  rowSelection: 'single' | 'multiple' = 'single';
  rowMultiSelectWithClick = false;
  currentRoute = '/';
  params;
  cols = [];
  savedColsArr = [];
  rows = [];
  colsArr = [];
  paginationPageSize;
  updateRowParams = {
    editingEnabled: false,
    isRowUpdated: false,
    isSelected: false,
  };
  editingEnabled = false;
  isRowUpdated = false;
  subscription: Subscription;
  modifysubscription: Subscription;
  reloadsubscription: Subscription;
  @Input() gridData: any;
  @Output() gridReady = new EventEmitter();
  public gridOptions: GridOptions;
  defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    maxWidth: 230,
    minWidth: 110,
    suppressSizeToFit: true,
    autoSizeColumns: true,
    suppressNavigable: true,
    suppressCellSelection: true,
    suppressMenu: true,
    floatingFilter: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellSelection: true,
    // suppressFloatingFilterButton: true
  };
  dataToEmit = {
    currentRoute: '',
    updateAction: '',
    updateData: {},
    oldPayload: {},
  };
  lastEditedRow: any;
  constructor() {
    super();
    this.currentRoute = this.router.url;
    this.paginationPageSize = 20;
    this.editType = 'fullRow';
    this.gridOptions = {
      // api: null,
      groupHeaderHeight: 40,
      headerHeight: 40,
      pagination: true,
      paginationPageSize: 20, 
      rowSelection: this.rowSelection,
      editType: 'fullRow',
      animateRows: true,
      rowBuffer: 20,
      rowMultiSelectWithClick: this.rowMultiSelectWithClick,
      undoRedoCellEditing: true,
      suppressDragLeaveHidesColumns: true,
      // stopEditingWhenGridLosesFocus: true,
      // enableRangeSelection: true,
      clipboardDelimiter: ",",
      processCellForClipboard: (params) => {
        console.log(params);
        return params.value.toString().toUpperCase(); // Custom processing
      },
      localeText: { noRowsToShow: "No data" },
      onRowValueChanged: (event: any) => {
        this.updateRowParams.isRowUpdated = true;
      },
      onRowEditingStarted: (event: any) => {
        this.updateRowParams.editingEnabled = true;
      },
      onRowEditingStopped: (event: any) => {
        this.updateRowParams.editingEnabled = false;
        this.updateRowParams.isSelected = false;
        this.updateRowParams.isRowUpdated = false;
      },
      onSelectionChanged: async (event: any) => {
        const count = await event.api.getSelectedNodes().length;
        this.eventSevice.emitselectionChangeEvent(count);
        this.updateRowParams.isSelected = true;
        this.updateRowParams.isRowUpdated = false;
        this.updateRowParams.editingEnabled = false;
      },
      onColumnMoved: (event: any) => {
        // if (event.column.colId && event.toIndex !== undefined) {
        //   this.modifyColumnOrder(event.column.colId, event.toIndex);
        // }
      },
      onBodyScroll: (event: any) => {
        if (event && event.direction == "horizontal") {
          this.modifyUIElements();
        }
      },
      onRowSelected: (event: any) => {
        let selectedNodes = event.api.getSelectedNodes();
        if (selectedNodes.length > 20) {
          event.node.setSelected(false);
          this.presentToast("Maximum 20 eDocket can be merged and downloaded");
        }
      },
    };
    // this.frameworkComponents = {
    //   buttonRenderer: ButtonRendererComponent,
    // };
  }

  ngOnInit() {
    this.rows = this.gridData.rows;
    this.cols = this.gridData.cols;
    this.savedColsArr = this.gridData.savedColsArr;
    if (!this.isNullEmptyVal(this.gridData.savedRecordCount)) {
      this.paginationPageSize = this.gridData.savedRecordCount;
    }
    if (this.savedColsArr && this.savedColsArr.length > 0) {
      this.colsArr = [];
      this.colsArr = this.savedColsArr;
    }
    if (this.gridData && this.gridData.multipleRowSelection) {
      this.rowSelection = "multiple";
      this.rowMultiSelectWithClick = true;
      this.gridOptions.rowSelection = this.rowSelection;
      this.gridOptions.rowMultiSelectWithClick = this.rowMultiSelectWithClick;
    } else {
      this.rowSelection = "single";
      this.rowMultiSelectWithClick = false;
      this.gridOptions.rowSelection = this.rowSelection;
      this.gridOptions.rowMultiSelectWithClick = this.rowMultiSelectWithClick;
    }
  }

  ngAfterViewInit() {
    const gridDiv = document.querySelector("#lhGrid");
    if (gridDiv !== undefined || gridDiv !== null) {
      gridDiv.addEventListener("keydown", this.onInput.bind(this));
    }
    // this.modifyUIElements();
  }

  modifyUIElements() {
    // Array.from(document.getElementsByClassName('ag-floating-filter-input')).forEach((ele) => {
    Array.from(document.getElementsByClassName("ag-input-field-input")).forEach(
      (ele) => {
        if (ele.attributes["disabled"]) {
          // skip columns with disabled filter
          return;
        }
        ele.setAttribute("placeholder", "Search");
        ele["style"]["padding"] = "3px";
      }
    );
  }
  onInput(event) {
    const keyCode = event.which || event.keyCode;
    const key = event.key || event.code;
    if (
      this.updateRowParams.editingEnabled &&
      (keyCode === 13 || key === "Enter")
    ) {
      this.updateRowParams.isRowUpdated = true;
      this.updateRowData();
    } else if (
      !this.updateRowParams.editingEnabled &&
      (keyCode === 27 || key === "Escape")
    ) {
      this.updateRowParams.isRowUpdated = false;
    }
  }

  updateRowData() {
    const selectedData = this.gridApi.getSelectedRows();
    console.log(selectedData);
    let flag = true;
    // Object.values(selectedData[0]).every(item => {
    //   if (item != '') {
    //     console.log(item);
    //     flag = this.XssValidator(item);
    //     return this.XssValidator(item);
    //   }
    // })
    if (!flag) {
      this.gridApi.undoCellEditing();
      return;
    }
    this.dataToEmit.currentRoute = this.currentRoute;
    this.dataToEmit.updateAction = "edit";
    this.dataToEmit.updateData = selectedData[0];
    this.dataToEmit.oldPayload = this.lastEditedRow;
    console.log(this.dataToEmit);
    console.log(this.updateRowParams);
    if (this.updateRowParams.isRowUpdated) {
      this.eventSevice.emitRowUpdate(this.dataToEmit);
    }
    this.lastEditedRow = undefined;
  }
  // onGridReady(params) {
  //   this.gridApi = params.api;
  //   this.gridColumnApi = params.columnApi;
  //   // this.gridApi.setGroupHeaderHeight(40);
  //   // this.gridApi.setHeaderHeight(45);
  //   const allColumnIds = [];
  //   params.columnApi.getAllColumns().forEach((column) => {
  //     allColumnIds.push(column.colId);
  //   });
  //   params.columnApi.autoSizeColumns(allColumnIds, false);
  //   if (this.savedColsArr && this.savedColsArr.length > 0) {
  //     console.log("No need to create new custom column array");
  //     this.handleColVisibility(this.savedColsArr);
  //   } else {
  //      this.getColumns();
  //   }
  //   this.gridReady.emit({
  //     gridObj: params.api,
  //     gridColumnApi: this.gridColumnApi,
  //     columns: this.colsArr,
  //     recordCount: this.paginationPageSize,
  //     gridOptions: this.gridOptions,
  //   });
  //   // params.api.sizeColumnsToFit();
  //   this.modifysubscription = this.eventSevice
  //     .getModifyTable()
  //     .subscribe((resp) => {
  //       this.modifyTable(resp);
  //     });

  //   this.reloadsubscription = this.eventSevice
  //     .getReloadTable()
  //     .subscribe((resp) => {
  //       this.reloadTable(resp);
  //     });
  //   this.gridApi.paginationSetPageSize(
  //     parseInt(this.paginationPageSize.toString())
  //   );
  // }

  //update this code beacuse
  //params.columnApi is undefined when you're trying to access getAllColumns().
  //To prevent this, ensure that params.columnApi is defined before using it:
  //   onGridReady(params) {

  //   this.gridApi = params.api;
  //   this.gridColumnApi = params.columnApi;

  //   // Safely access getAllColumns()
  //   if (this.gridColumnApi?.getAllColumns) {
  //     const allColumnIds = this.gridColumnApi.getAllColumns().map(col => col.getColId());
  //     this.gridColumnApi.autoSizeColumns(allColumnIds, false);
  //   } else {
  //     console.warn('columnApi.getAllColumns is not available');
  //   }

  //   if (this.savedColsArr && this.savedColsArr.length > 0) {
  //     console.log("No need to create new custom column array");
  //     this.handleColVisibility(this.savedColsArr);
  //   } else {
  //     this.getColumns();
  //   }

  //   this.gridReady.emit({
  //     gridObj: this.gridApi,
  //     gridColumnApi: this.gridColumnApi,
  //     columns: this.colsArr,
  //     recordCount: this.paginationPageSize,
  //     gridOptions: this.gridOptions,
  //   });

  //   this.modifysubscription = this.eventSevice
  //     .getModifyTable()
  //     .subscribe((resp) => {
  //       this.modifyTable(resp);
  //     });

  //   this.reloadsubscription = this.eventSevice
  //     .getReloadTable()
  //     .subscribe((resp) => {
  //       this.reloadTable(resp);
  //     });

  //   // this.gridApi.paginationSetPageSize(Number(this.paginationPageSize));
  //     // this.gridApi.setPaginationPageSize(Number(this.paginationPageSize));
  //     this.gridApi.setGridOption('paginationPageSize', Number(this.paginationPageSize));
  // }
  onGridReady(params) {
    this.gridApi = params.api;

    // Safely auto-size columns if available
    setTimeout(() => {
      const allColumns = this.gridApi.getColumns();
      if (allColumns && allColumns.length) {
        const allColumnIds = allColumns.map((col) => col.getColId());
        this.gridApi.autoSizeColumns(allColumnIds, false);
      } else {
        console.warn("getAllColumns returned null or empty");
      }
    }, 0);

    // Use saved columns if present
    if (this.savedColsArr && this.savedColsArr.length > 0) {
      console.log("No need to create new custom column array");
      this.handleColVisibility(this.savedColsArr);
    } else {
      this.getColumns();
    }

    // Emit grid ready event
    this.gridReady.emit({
      gridObj: this.gridApi,
      columns: this.colsArr,
      recordCount: this.paginationPageSize,
      gridOptions: this.gridOptions,
    });

    // Subscribe to modify and reload events
    this.modifysubscription = this.eventSevice
      .getModifyTable()
      .subscribe((resp) => {
        this.modifyTable(resp);
      });

    this.reloadsubscription = this.eventSevice
      .getReloadTable()
      .subscribe((resp) => {
        this.reloadTable(resp);
      });

    // Set pagination page size
    this.gridApi.setGridOption(
      "paginationPageSize",
      Number(this.paginationPageSize)
    );
  }

  ngOnDestroy() {
    if (this.modifysubscription) {
      this.modifysubscription.unsubscribe();
    }

    if (this.reloadsubscription) {
      this.reloadsubscription.unsubscribe();
    }
    // this.modifysubscription.unsubscribe();
    // this.reloadsubscription.unsubscribe();
  }

  onRemoveSelected() {
    const selectedData = this.gridApi.getSelectedRows();
    this.gridApi.applyTransaction({ remove: selectedData });
  }

  onCellClicked($event) {
    // if (this.editingRowIndex !== $event.rowIndex) {
    console.log($event);
    console.log(this.currentRoute);
    if (
      this.currentRoute == "/outbound-trips" ||
      this.currentRoute == "/humes-deliveries"
    ) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText($event.value).then(
          () => {
            console.log("Copied to clipboard successfully!");
          },
          (err) => {
            console.error("Failed to copy the text to clipboard.", err);
          }
        );
      }
    }

    let lastEdit = Object.assign({}, $event.data);
    this.lastEditedRow = lastEdit;
    this.gridApi.startEditingCell({
      rowIndex: $event.rowIndex,
      colKey: $event.column.colId,
    });
    //   this.editingRowIndex = $event.rowIndex;
    // }
  }

  getColumns() {
    if (this.gridApi) {
      this.colsArr = [];
      this.colsArr = this.createGridColArr(this.gridApi);
    }
  }

  async handleColVisibility(data) {
    if (data && data.length > 0) {
      data.forEach((item) => {
        if (item) {
          if (item.visibility === false) {
            this.gridApi.setColumnsVisible([item.id], false);
          } else {
            this.gridApi.setColumnsVisible([item.id], true);
          }
        }
        // this.gridApi.setColumnVisible(item.id, item.visibility !== false);
      });
    }
  }

  // async modifyTable(data) {
  //   if (data && data.recordCount !== null) {
  //     this.paginationPageSize = data.recordCount;
  //     // await this.gridApi.paginationSetPageSize(
  //     //   parseInt(data.recordCount.toString())
  //     // );
  //     await this.gridApi.updateGridOptions(
  //       parseInt(data.recordCount.toString())
  //     );
  //      this.gridApi.paginationGoToPage(0);
  //   }
  //   if (data && data.columns !== undefined && data.columns.length > 0) {
  //     this.colsArr = [];
  //     this.colsArr = data.columns;
  //     await data.columns.forEach((item) => {
  //       if (item.visibility === false) {
  //         this.gridApi.setColumnsVisible([item.id], false);
  //       } else {
  //         this.gridApi.setColumnsVisible([item.id], true);
  //       }
  //     });
  //   }
  //   await this.gridReady.emit({
  //     gridObj: this.gridApi,
  //     columns: data.columns,
  //     recordCount: this.paginationPageSize,
  //   });
  // }

  async modifyTable(data) {
    if (data && data.recordCount !== null) {
      this.paginationPageSize = Number(data.recordCount);

      // way to update page size
      await this.gridApi.updateGridOptions(
        parseInt(data.recordCount.toString())
      );

      // Reset to the first page
      this.gridApi.paginationGoToPage(0);
    }

    if (data && data.columns && data.columns.length > 0) {
      this.colsArr = data.columns;

      // ✅ Apply column visibility settings
      data.columns.forEach((item) => {
        this.gridApi.setColumnsVisible([item.id], item.visibility !== false);
      });
    }

    console.log("Modify:  " + this.paginationPageSize);

    this.gridReady.emit({
      gridObj: this.gridApi,
      columns: this.colsArr,
      recordCount: this.paginationPageSize,
    });
  }

  async reloadTable(resp) {
    this.savedColsArr = [];
    this.rows = resp.rows;
    this.cols = resp.cols;
    this.savedColsArr = resp.savedColsArr;
  
  // Reset filters
  if (this.gridApi) {
    this.gridApi.setFilterModel(null);        // Clear all ag-Grid filters
    this.gridApi.onFilterChanged();           // Apply the change
    this.gridApi.paginationGoToFirstPage();   // Optional: reset to first page
    this.gridApi.setGridOption('rowData', resp.rows);  // Corrected method
  }

    if (resp && resp.multipleRowSelection) {
      this.rowSelection = "multiple";
      this.gridOptions.rowSelection = this.rowSelection;
    } else {
      this.rowSelection = "single";
      this.gridOptions.rowSelection = this.rowSelection;
    }
  }
}
